import React, {useContext} from 'react';

import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {
    SimpleActionButton,
} from 'components/form/components';
import {RequestCardContext} from 'components/request/replies/context/request-card-context';
import {EButtonType} from 'entities/metadata';

interface IEditingFormButtonProps {
    buttonType?: EButtonType;
    actionIcon?: TIconType;
    text?: string;
    onSubmit?: () => void;
}

export const EditingAndSaveFormButton = ({
    actionIcon,
    buttonType,
    text,
    onSubmit,
}: IEditingFormButtonProps) => {
    const {isEditing, setEditing} = useContext(RequestCardContext);
    const handleClick = () => {
        if (onSubmit) onSubmit();
    };
    return (
        <>
            <SimpleActionButton
                disabled={!isEditing}
                type={buttonType || 'primary'}
                htmlType="submit"
                icon="Save"
                onClick={handleClick}
                title="Сохранить"
            />
            <SimpleActionButton
                disabled={isEditing}
                type={buttonType || 'primary'}
                onClick={setEditing}
                icon={actionIcon}
                title={text || 'Редактировать'}
            />
        </>

    );
};
